document.addEventListener("DOMContentLoaded", function () {
  var searchToggle = document.querySelector("[data-search-toggle]");
  var searchBox = document.querySelector("[data-search-box]");
  var mobileToggle = document.querySelector("[data-mobile-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");

  if (searchToggle && searchBox) {
    searchToggle.addEventListener("click", function () {
      var open = searchBox.classList.toggle("is-open");
      searchToggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) { var input = searchBox.querySelector("input"); if (input) input.focus(); }
    });
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", function () {
      var open = mobileMenu.classList.toggle("is-open");
      mobileToggle.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("sf-nav-open", open);
    });
    mobileMenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        mobileMenu.classList.remove("is-open");
        mobileToggle.setAttribute("aria-expanded", "false");
        document.body.classList.remove("sf-nav-open");
      });
    });
  }

  var price = document.getElementById("sf-product-price");
  var options = document.querySelectorAll(".sf-variant-option");
  options.forEach(function (option) {
    var input = option.querySelector("input");
    if (!input) return;
    input.addEventListener("change", function () {
      options.forEach(function (el) { el.classList.remove("is-selected"); });
      option.classList.add("is-selected");
      if (price) price.textContent = input.dataset.price || "";
      var btn = document.querySelector(".sf-buy-main");
      if (btn) {
        btn.disabled = input.disabled;
        var label = btn.querySelector("[data-buy-label]");
        if (label) label.textContent = input.disabled ? "Niedostępny" : "Dodaj do koszyka";
      }
    });
  });

  function replacePrivacyText(root) {
    if (!root) return;
    var map = {
      "Cookie consent": "Pliki cookies",
      "Cookie Consent": "Pliki cookies",
      "Accept": "Akceptuj",
      "Accept all": "Akceptuj",
      "Accept All": "Akceptuj",
      "Reject": "Odrzuć",
      "Reject all": "Odrzuć",
      "Reject All": "Odrzuć",
      "Decline": "Odrzuć",
      "Decline all": "Odrzuć",
      "Decline All": "Odrzuć"
    };
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var key = node.nodeValue.trim();
      if (map[key]) node.nodeValue = node.nodeValue.replace(key, map[key]);
    }
  }

  function sizePrivacyBanner() {
    var banner = document.querySelector("#shopify-pc__banner");
    if (!banner) return;
    var css = { maxWidth: "min(520px, calc(100vw - 32px))", width: "auto", left: "auto", right: "16px", bottom: "16px" };
    Object.keys(css).forEach(function (key) { banner.style[key] = css[key]; });
    if (window.innerWidth <= 720) {
      banner.style.maxWidth = "calc(100vw - 24px)";
      banner.style.left = "12px";
      banner.style.right = "12px";
      banner.style.bottom = "12px";
    }
  }

  function localizePrivacyBanner() {
    var banner = document.querySelector("#shopify-pc__banner");
    if (!banner) return;
    replacePrivacyText(banner);
    if (banner.shadowRoot) replacePrivacyText(banner.shadowRoot);
    sizePrivacyBanner();
  }

  localizePrivacyBanner();
  window.addEventListener("resize", sizePrivacyBanner);
  var privacyObserver = new MutationObserver(function () { localizePrivacyBanner(); });
  privacyObserver.observe(document.documentElement, {subtree: true, childList: true, characterData: true});

  /* Judge.me product reviews modal */
  var reviewModal = null;
  var reviewWidget = null;
  var reviewPlaceholder = null;
  var reviewObserver = null;
  var reviewHideTimer = null;

  function findReviewWidget() {
    return document.querySelector("#judgeme_product_reviews") ||
           document.querySelector(".jdgm-rev-widg");
  }

  function findReviewBadge() {
    return document.querySelector(".sf-product-copy .jdgm-preview-badge") ||
           document.querySelector(".jdgm-preview-badge");
  }

  function ensureReviewCss() {
    if (document.getElementById("sf-jm-modal-style")) return;
    var style = document.createElement("style");
    style.id = "sf-jm-modal-style";
    style.textContent = `
      .sf-jm-hidden-from-page {
        position: fixed !important;
        left: -100000px !important;
        top: 0 !important;
        width: 1px !important;
        height: 1px !important;
        max-height: 1px !important;
        overflow: hidden !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      .sf-jm-modal {
        position: fixed !important;
        inset: 0 !important;
        z-index: 2147483647 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 16px !important;
      }
      .sf-jm-backdrop {
        position: absolute !important;
        inset: 0 !important;
        background: rgba(0,0,0,.62) !important;
      }
      .sf-jm-dialog {
        position: relative !important;
        z-index: 1 !important;
        width: min(960px, 100%) !important;
        max-height: calc(100vh - 32px) !important;
        overflow: auto !important;
        background: #fff !important;
        border-radius: 18px !important;
        box-shadow: 0 24px 80px rgba(0,0,0,.35) !important;
        padding: 52px 20px 20px !important;
      }
      .sf-jm-close {
        position: absolute !important;
        top: 10px !important;
        right: 12px !important;
        width: 40px !important;
        height: 40px !important;
        border: 0 !important;
        border-radius: 50% !important;
        background: #f3f3f3 !important;
        color: #111 !important;
        font-size: 30px !important;
        line-height: 1 !important;
        cursor: pointer !important;
        z-index: 2 !important;
      }
      .sf-jm-dialog #judgeme_product_reviews,
      .sf-jm-dialog .jdgm-rev-widg {
        position: static !important;
        left: auto !important;
        top: auto !important;
        width: 100% !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      body.sf-jm-modal-open { overflow: hidden !important; }
      @media (max-width: 720px) {
        .sf-jm-modal { padding: 8px !important; }
        .sf-jm-dialog {
          width: 100% !important;
          max-height: calc(100vh - 16px) !important;
          border-radius: 14px !important;
          padding: 46px 10px 12px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function hideReviewWidgetNow() {
    if (reviewModal) return;
    var widget = findReviewWidget();
    if (!widget) {
      if (!reviewHideTimer) reviewHideTimer = setTimeout(function () {
        reviewHideTimer = null;
        hideReviewWidgetNow();
      }, 200);
      return;
    }
    widget.classList.add("sf-jm-hidden-from-page");
  }

  function closeReviewModal() {
    if (!reviewModal) return;
    var modal = reviewModal;
    var widget = reviewWidget;
    var placeholder = reviewPlaceholder;

    if (widget && placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(widget, placeholder.nextSibling);
    }

    modal.remove();
    reviewModal = null;
    document.body.classList.remove("sf-jm-modal-open");
    reviewWidget = null;
    reviewPlaceholder = null;

    if (widget) widget.classList.add("sf-jm-hidden-from-page");
    if (placeholder) placeholder.remove();
    setTimeout(hideReviewWidgetNow, 0);
  }

  function openReviewModal() {
    if (reviewModal) return;
    ensureReviewCss();

    var widget = findReviewWidget();
    if (!widget) {
      setTimeout(openReviewModal, 200);
      return;
    }

    reviewWidget = widget;
    reviewPlaceholder = document.createComment("judge-me-review-modal-placeholder");
    widget.parentNode.insertBefore(reviewPlaceholder, widget);
    widget.classList.remove("sf-jm-hidden-from-page");

    reviewModal = document.createElement("div");
    reviewModal.className = "sf-jm-modal";
    reviewModal.innerHTML = "<div class='sf-jm-backdrop' data-jm-close></div><div class='sf-jm-dialog' role='dialog' aria-modal='true' aria-label='Opinie produktu'><button type='button' class='sf-jm-close' data-jm-close aria-label='Zamknij'>×</button><div class='sf-jm-content'></div></div>";
    document.body.appendChild(reviewModal);

    reviewModal.querySelector(".sf-jm-content").appendChild(widget);
    document.body.classList.add("sf-jm-modal-open");

    reviewModal.addEventListener("click", function (event) {
      if (event.target.closest("[data-jm-close]")) closeReviewModal();
    });
  }

  function bindReviewBadge() {
    var badge = findReviewBadge();
    if (!badge || badge.dataset.sfJmBound === "1") return;
    badge.dataset.sfJmBound = "1";
    badge.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      openReviewModal();
    }, true);
  }

  ensureReviewCss();
  bindReviewBadge();
  hideReviewWidgetNow();

  reviewObserver = new MutationObserver(function () {
    if (!reviewModal) {
      bindReviewBadge();
      hideReviewWidgetNow();
    }
  });
  reviewObserver.observe(document.documentElement, { subtree: true, childList: true });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeReviewModal();
  });
});